export default __webpack_public_path__ + "assets/images/154f76ad2819257ea81ba22697e5f2af.svg";